module.exports = __webpack_public_path__ + "img/sports_supplier.df463079.svg";